"use client";

import { getBrandValuesFilterKey } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/getBrandValuesFilterKey";
import { useSDUIFilterablePaginatedSectionState } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
import { ICategoryPageMatch } from "@faire/retailer-shared/categories/ICategoryPageMatch";
import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

export const useSDUIFilterablePaginatedSectionFilters = () => {
  const { filterKeys } = useSDUIFilterablePaginatedSectionState();
  const match = useRouteMatch<ICategoryPageMatch>();

  return useMemo(() => {
    const brandValueFilterKey = getBrandValuesFilterKey(
      match.params.brandValue
    );

    if (brandValueFilterKey && !filterKeys.includes(brandValueFilterKey)) {
      filterKeys.push(brandValueFilterKey);
    }
    return filterKeys;
  }, [filterKeys, match.params.brandValue]);
};
